<template>
    <base-layout title="活动记录">
        <template slot="main">
            <div class="page-body">
                <div class="concent">
                    <scroller class="scroller-view" :on-refresh="refresh" :on-infinite="infinite">
                        <div class="body">
                            <ul class="record-list">
                                <li v-for="(item,index) in recordList" :key="index" class="list">
                                    <div class="content">
                                        <div class="name">{{ item.giftName }}</div>
                                        <div class="time">{{ item.createTime }}</div>
                                    </div>
                                    <div class="btn" @click="toMyCoupon">
                                        <div class="btn-bg">
                                            <div class="button">去查看</div>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="isEnd" class="list-end">—— 没有更多数据 ——</li>
                            </ul>
                        </div>
                    </scroller>
                </div>
            </div>
        </template>
    </base-layout>
</template>

<script>
import baseLayout from '@comm/view/layout/baseLayout';
import { CMS_Methods } from '@comm/store/cms.store';
import { env, envConfig } from '@utils/env'
// 下拉刷新组件
import scroller from 'vue-scroller'
// 微信数据存储
import wechatStore from "@comm/store/wechat/wechat.store";

export default{
    name: 'expansionRecord',
    components: {
        baseLayout,
        scroller: scroller.Scroller,
    },
    data() {
        return {
            recordList: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            isEnd: false,
        }
    },
    mounted() {
        this.init();
        wechatStore.dispatch("luckyDrawWechatShare", this.shareId);
    },
     methods: {
        toMyCoupon() {
            // 跳转到我的优惠券
            this.$router.push({
                path: '/my/coupon/list'
            })
        },
        init() {
            let pages = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }
            CMS_Methods.luckyDraw50pointsRecords(pages).then((res) => {
                if(this.pageNum == 1){
                    this.recordList = res.records;
                }else{
                    this.recordList = this.recordList.concat(res.records);
                }

                this.total = Number(res.total);
                this.isEnd = this.recordList.length >= this.total || !this.recordList.length;
            }).catch(() => {
                this.recordList = [];
                this.isEnd = true;
            })
        },
        // 抽奖列表数据请求
        request(action) {
            return new Promise((resolve, reject) => {
                // 对应的状态分页数据
                const pagingData = this.recordList;
                // 检查请求
                switch (action) {
                    // 下一页
                    case "next":
                        if (!this.isEnd && pagingData.length && pagingData.length < this.total) {
                            this.pageNum++;
                            this.init();
                            return resolve();
                        }else{
                            this.isEnd = true;
                            return resolve();
                        }
                        break;
                    // 刷新
                    case "refresh":
                        // 检查是否已经请求过数据
                        if (pagingData.length) {
                            this.recordList = [];
                            this.pageNum = 1;
                            this.init();
                            return resolve();
                        }else{
                            return resolve();
                        }
                        break;
                }
            });
        },
        // 下拉刷新
        refresh(done) {
            this.request("refresh").then(
                () => {
                    done();
                },
                () => {
                    done();
                }
            );
        },
        // 无限加载回调
        infinite(done) {
            // 对应的状态分页数据
            const pagingData = this.recordList;
            if (this.isEnd || !pagingData.length) return done(true);

            this.request("next").then(
                () => {
                    done(true);
                },
                () => {
                    done(true);
                }
            );
        },
    },
}
</script>

<style lang="scss" scoped>
    // @import "~@assets/style/app/var.scss";
    .page-body {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("../_img/member/integralActivity/50pts_records_bg.png");
        background-color: #fd8b59;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .concent {
            position: relative;
            width: 88%;
            height: 80%;
            left: 6%;
            top: 14%;
            background-image: url("../_img/member/integralActivity/record_box.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .scroller-view {
                width: 100%;
                height: 97% !important;
                margin-top: 2px;
                .body {
                    width: 100%;
                    height: 100%;
                    padding: 1.2% 7.2% 0 7.2%;
                    .record-list {
                        .list {
                            box-sizing: border-box;
                            padding: 10px 0;
                            display: flex;
                            border-bottom: 1px solid #ddbbad;
                            .content{
                                flex: 1;
                                color: #833119;
                                .name{
                                    font-size: 16px;
                                    font-family: "Alimama ShuHeiTi", sans-serif;
                                }
                                .time{
                                    font-size: 12px;
                                    margin-top: 6px;
                                }
                            }

                            .btn {
                                margin-left: 1%;
                                width: 24%;
                                display: flex;
                                align-items: center;
                                .btn-bg {
                                    width: 100%;
                                    height: 35px;
                                    border-radius: 5px;
                                    background: #d41c28;
                                    .button {
                                        font-size: 16px;
                                        width: 100%;
                                        height: 30px;
                                        border-radius: 5px;
                                        background: #ed2f3b;
                                        color: #fff;
                                        font-weight: bold;
                                        line-height: 30px;
                                        text-align: center;
                                        font-family: "Alimama ShuHeiTi", sans-serif;
                                    }
                                }
                                
                            }
                        }
                    }

                    .list-end {
                        text-align: center;
                        font-size: 12px;
                        color: #ddbbad;
                        margin-top: 13px;
                        padding-bottom: 13px;
                    }
                }
                /deep/ .loading-layer {
                    display: none !important;
                }
            }
        }
    }
    
    .font-tips{
        text-align: center;
        font-size: 12px;
        color: #999;
        margin-top: 10px;
    }

    
</style>
